const theme = {
  primary: 'rgba(115, 103, 240)',
  secondary: 'rgba(130, 134, 139)',
  success: 'rgba(40, 199, 111)',
  warning: 'rgba(255, 159, 67)',
  danger: 'rgba(234, 84, 85)',
  info: 'rgba(0, 207, 232)',
  dark: 'rgba(30, 30, 30)',
  light: 'rgba(246, 246, 246)',
};

export default theme;
